<script>
import GameCardWithLink from './GameCardWithLink.vue';
import GameCardPlaceholder from './GameCardPlaceholder';
import { Slider } from 'vue-sliderx';

export default {
  name: 'StationTagRow',
  props: {
    stationTag: {
      required: true,
    },
    loading: {
      type: Boolean,
    },
  },
  components: {
    GameCardWithLink,
    GameCardPlaceholder,
    Slider,
  },
  computed: {
    gamesToDisplay () {
      // return this.stationTag.games.length < 4
      //   ? Array(4).fill(null).map((v, i) => this.stationTag.games[i % this.stationTag.games.length])
      //   : this.stationTag.games
      return this.stationTag.games;
    },
  },
  data: () => ({
    hoveredGame: 0,
  }),
  methods: {
    getTransformAnchor (index) {
      const isFirstInCol = index % 4 === 0;
      const isLastInCol = index % 4 === (4 - 1);
      let xAnchor = 50;
      if (isFirstInCol) xAnchor = 0;
      if (isLastInCol) xAnchor = 100;
      return `${xAnchor}% 50%`;
    },
  },
};
</script>

<template lang="pug">
div.games-grid-row.flex.flex-column
  h1.cattitle.white.b.f5.ttu.mh05(v-if="!loading") {{ stationTag.text }}
  div.cattitleplaceholder.white.b.f5.ttu.mb2.bg-black-overlay.dib.w-40.h1.o-20.ml4(v-else)
  div.row.flex.flex-auto.h0(v-if="!loading")
    slider.slider.h-100.flex-auto.ph4(:offset="0", :navigation-increment="4", :loop="false", :clone="false", :class="!hoveredGame ? '' : '-offset' ", ref="carousel", orientation="horizontal", :per-page="4")
      game-card-with-link.gamecard.mh05(:game="game", v-for="(game, i) in gamesToDisplay", :key="game.id + i", :style="{ transformOrigin: getTransformAnchor(i)}")
      arrow-button.arrowbtn.pa2.ph1.rotate-180.absolute.left-0.top-0(vertical, slot="prev", slot-scope="{ canPrev, prev }", @click="prev", :style="{ visibility: !canPrev ? 'hidden' : 'visible'}")
      arrow-button.arrowbtn.pa2.ph1.absolute.right-0.top-0(vertical, slot="next", slot-scope="{ canNext, next }", @click="next", :style="{ visibility: !canNext ? 'hidden' : 'visible'}")
  div.row.flex.pl4(v-else)
    div.placeholderrow.flex-auto.mr2
      grid-container.w-100(:col="4")
        div(v-for="index in 4", :key="index")
          game-card-placeholder.gameplaceholder.h-100(:style="{ animationDelay: `${index*500}ms`}")
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "styles/variables.css";
.games-grid-row {
  & .cattitle {
    padding-left: 5.1rem;
  }
  & .row {
    position: relative;
  }
  & .slider {
    margin-left: 2rem;
    margin-right: 2rem;
    & >>> .elwrapper {
      padding: 1rem 0;
      padding-top: 1.2rem;
    }
    & >>> .gamecard {
      &:hover {
        transition: transform 0.3s ease-in-out;
        transform: scale(1.1, 1.1);
        position: relative;
        z-index: 10;
      }
    }
  }
  & .arrowbtn {
    height: calc(100% - 2.95rem);
    margin-top: 1.2rem;
    width: 5rem;
  }
}
</style>
